export default __webpack_public_path__ + "static/media/Cars_12.3333ef44.png";